import type {
  Maybe,
  ResumeOriginType,
  VirusScanStatus,
} from 'src/types/graphql';

export enum FileStatus {
  FILE_OK = 'FILE_OK',
  FILE_EXPORT_OK = 'FILE_EXPORT_OK',
  FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR',
  FILE_EXPORT_ERROR = 'FILE_EXPORT_ERROR',
  FILE_UPLOADING = 'FILE_UPLOADING',
  FILE_EXPORTING = 'FILE_EXPORTING',
  FILE_OPEN_ERROR = 'FILE_OPEN_ERROR',
}

export interface Resume {
  id: string;
  createdDateUtc: string;
  fileMetadata: {
    name: string;
    size: string;
    virusScanStatus: VirusScanStatus;
    sensitiveDataInfo: { isDetected: boolean } | null;
    uri: string;
  };
  isDefault: boolean;
  origin: { type: Maybe<ResumeOriginType> };
  deleteRequested?: boolean;
  fetchedStatus?: boolean;
  statusFetched?: boolean;
}

export interface UploadResume {
  file: File;
  id: string;
  isDefault: boolean;
}

export type Origin = 'Generated' | 'Uploaded' | '';
